import { InteractionStatus } from '@azure/msal-browser';
import {
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react';
import { useLazyVerifyTokenQuery } from '../../services/auth';
import { useEffect } from 'react';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../reduxActions/alert';

export const useAuthHelper = () => {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [verifyToken] = useLazyVerifyTokenQuery();
  const dispatch = useAppDispatch();

  const showError = (
    err: string = 'authentication failed'
  ) => {
    dispatch(
      showAlert({
        content: err,
        severity: 'error',
      })
    );
  };

  useEffect(() => {
    if (
      isAuthenticated &&
      inProgress === InteractionStatus.None
    ) {
      instance
        .acquireTokenSilent({
          account: accounts[0],
          scopes: ['User.Read'],
        })
        .then((response) => {
          verifyToken({
            token: response.accessToken,
          })
            .unwrap()
            .catch((err) => {
              showError(err.data.error);
            });
        })
        .catch(() => {
          showError();
        });
    }
  }, [inProgress, isAuthenticated, accounts, instance]);
};
